import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { SiteHeader } from "@/components/site/SiteHeader";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function LegalPage({ slug }) {
  const params = useParams();
  const s = slug || params.slug;
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    api.get(`/pages/${s}`).then((r) => setPage(r.data)).catch(() => setPage(null));
  }, [s]);

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50">
      <SiteHeader />
      <div className="mx-auto max-w-3xl px-5 py-14">
        {page === undefined ? (
          <div className="grid h-40 place-items-center"><Loader2 className="animate-spin text-zinc-600" /></div>
        ) : page === null ? (
          <div className="text-[14px] text-zinc-500">Not found.</div>
        ) : (
          <>
            <h1 className="text-2xl font-semibold tracking-tight text-zinc-50">{page.title}</h1>
            <p className="mt-1 text-[12px] text-zinc-600">Updated {new Date(page.updated_at).toLocaleDateString()}</p>
            <div className="mt-6 whitespace-pre-line text-[14px] leading-relaxed text-zinc-300">{page.content}</div>
          </>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}
